//Constants
import { hostPath } from "../Constants/constants";

//JWT Decoder
import jwtDecode from "jwt-decode";

/**
 * Function to extract a value from URL by giving a element
 * @param {String} element is the element to search in the url
 * @returns the value obtained from the url
 */
export const urlSearch = (element) => {
  return new URLSearchParams(window.location.search).get(element);
};

export const fetchWithTokenJSONPost = async (
  path,
  body,
  verification = true,
  publicRoute = false
) => {
  try {
    if (publicRoute) {
      return fetch(hostPath + path, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-type": "application/json",
        },
      });
    }

    //Get the token
    const token = localStorage.token?.replace(/"/g, "");

    //Token decodification
    let decodedToken = null;
    try {
      decodedToken = jwtDecode(token);
    } catch (e) {
      decodedToken = null;
    }

    //This is usefull in case the token expires while the user in a session and refreshes some data
    //Check if theres a valid token and if its not expired before fetching the data and wasting monkey time
    if (decodedToken && new Date().getTime() < decodedToken.exp * 1000) {
      return fetch(hostPath + path, {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-type": "application/json",
          authorization: `Bearer ${token}`,
        },
      });
    } else {
      localStorage.removeItem("token");
      if (verification) {
        window.location.href = "/";
      }
      return null;
    }
  } catch (e) {
    console.log(e);
    localStorage.removeItem("token");
    window.location.href = "/";
    return null;
  }
};
